import { toast } from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    requestGetReportLayouts,
    requestGetReportLayoutById,
    requestInsertReportLayout,
    requestUpdateReportLayout,
    requestDeleteReportLayout,

    requestGetJobs,
    requestGetJobProducts
} from "api/menu/master-files/report-builder/requests";

export const REPORT_LAYOUTS_LOADING = "REPORT_LAYOUTS_LOADING";
export const REPORT_LAYOUTS_ERRORS = "REPORT_LAYOUTS_ERRORS";

export const REPORT_LAYOUTS_GET = "REPORT_LAYOUTS_GET";
export const REPORT_LAYOUTS_GET_BY_ID = "REPORT_LAYOUTS_GET_BY_ID";
export const REPORT_LAYOUTS_INSERT = "REPORT_LAYOUTS_INSERT";
export const REPORT_LAYOUTS_UPDATE = "REPORT_LAYOUTS_UPDATE";
export const REPORT_LAYOUTS_DELETE = "REPORT_LAYOUTS_DELETE";

export const REPORT_LAYOUTS_JOBS = "REPORT_LAYOUTS_JOBS";
export const REPORT_LAYOUTS_JOB_PRODUCTS = "REPORT_LAYOUTS_JOB_PRODUCTS";

export const setLoading = (status) => ({
    type: REPORT_LAYOUTS_LOADING,
    payload: status
});

export const getReportLayouts = () => dispatch => {
    dispatch(setLoading(true));
    requestGetReportLayouts()
        .then(response => {
            dispatch({
                type: REPORT_LAYOUTS_GET,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, REPORT_LAYOUTS_ERRORS));
        });
};

export const getReportLayoutById = (reportId) => dispatch => {
    dispatch(setLoading(true));
    requestGetReportLayoutById(reportId)
        .then(response => {
            dispatch({
                type: REPORT_LAYOUTS_GET_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, REPORT_LAYOUTS_ERRORS));
        });
};

export const insertReportLayout = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestInsertReportLayout(data)
        .then(response => {
            dispatch({
                type: REPORT_LAYOUTS_INSERT,
                payload: response.data
            });
            callback();
            toast("Report created successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, REPORT_LAYOUTS_ERRORS));
        });
};

export const updateReportLayout = (reportId, data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateReportLayout(reportId, data)
        .then(response => {
            dispatch({
                type: REPORT_LAYOUTS_UPDATE,
                payload: response.data
            });
            callback();
            toast("Report updated successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, REPORT_LAYOUTS_ERRORS));
        });
};

export const deleteReportLayout = (reportId) => dispatch => {
    dispatch(setLoading(true));
    requestDeleteReportLayout(reportId)
        .then(() => {
            dispatch({
                type: REPORT_LAYOUTS_DELETE,
                payload: reportId
            });
            toast("Report removed successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, REPORT_LAYOUTS_ERRORS));
        });
};

export const getJobs = () => dispatch => {
    dispatch(setLoading(true));
    requestGetJobs()
        .then(response => {
            dispatch({
                type: REPORT_LAYOUTS_JOBS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, REPORT_LAYOUTS_ERRORS));
        });
};

export const getJobProducts = (jobId) => dispatch => {
    dispatch(setLoading(true));
    requestGetJobProducts(jobId)
        .then(response => {
            dispatch({
                type: REPORT_LAYOUTS_JOB_PRODUCTS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, REPORT_LAYOUTS_ERRORS));
        });
};
